import { ApiError } from "../api";

// "Can't reach the server" (no network, or the server erroring) is not the same as
// "logged out". Only a real 401 should send someone to the login screen; otherwise an
// installed app opened without signal would throw away a perfectly good session.
const KEY = "signedIn";

export function rememberSignedIn(value: boolean): void {
  try {
    if (value) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // Blocked storage: the app just behaves as before (offline opens go to login).
  }
}

export function wasSignedIn(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export type AuthOutcome = "authenticated" | "anonymous" | "offline-authenticated";

// The result of the "am I logged in?" check, given what went wrong (if anything).
export function outcomeAfterSessionCheck(error: unknown, previouslySignedIn: boolean): AuthOutcome {
  if (error === null) return "authenticated";
  const unreachable = error instanceof ApiError && (error.status === 0 || error.status >= 500);
  return unreachable && previouslySignedIn ? "offline-authenticated" : "anonymous";
}
